import { auth } from "./auth";
import { autumnPointBack } from "./autumnPointBack";
import { avatar } from "./avatar";
import { banner } from "./banner";
import { board } from "./board";
import { bookmarkList } from "./bookmarkList";
import { call } from "./call";
import { callError } from "./callError";
import { chat } from "./chat";
import { cocoplusLive } from "./cocoplusLive";
import { common } from "./common";
import { contact } from "./contact";
import { dailyBonus } from "./dailyBonus";
import { demoCall } from "./demoCall";
import { discover } from "./discover";
import { editProfile } from "./editProfile";
import { eimiCampaign } from "./eimiCampaign";
import { favorite } from "./favorite";
import { favoritesPage } from "./favoritesPage";
import { fleamarket } from "./fleamarket";
import { footprint } from "./footprint";
import { forceUpdate } from "./forceUpdate";
import { gallery } from "./gallery";
import { gift } from "./gift";
import { highReviewOnboarding } from "./highReviewOnboarding";
import { hokageMigration } from "./hokageMigration";
import { insufficientPointSheet } from "./insufficientPointSheet";
import { landing } from "./landing";
import { likeList } from "./likeList";
import { live } from "./live";
import { lovenseLp } from "./lovenseLp";
import { media } from "./media";
import { messages } from "./messages";
import { moderation } from "./moderation";
import { myProfile } from "./myProfile";
import { nav } from "./nav";
import { news } from "./news";
import { newUserPointBack } from "./newUserPointBack";
import { notification } from "./notification";
import { onboarding } from "./onboarding";
import { preroutePrompt } from "./preroutePrompt";
import { profile } from "./profile";
import { purchase } from "./purchase";
import { pushSoftAsk } from "./pushSoftAsk";
import { recommend } from "./recommend";
import { review } from "./review";
import { reviewLp } from "./reviewLp";
import { search } from "./search";
import { settings } from "./settings";
import { signupBonus } from "./signupBonus";
import { superChat } from "./superChat";
import { validation } from "./validation";
import { videoCallTab } from "./videoCallTab";

/**
 * アプリ内文言の一元管理。
 * 旧 i18n（locales/ja.json）から移行。補間は関数値で表現する。
 */
export const TEXT = {
  common,
  videoCallTab,
  cocoplusLive,
  validation,
  nav,
  recommend,
  landing,
  chat,
  gift,
  myProfile,
  editProfile,
  auth,
  hokageMigration,
  discover,
  eimiCampaign,
  messages,
  profile,
  news,
  newUserPointBack,
  moderation,
  notification,
  call,
  avatar,
  purchase,
  board,
  review,
  reviewLp,
  lovenseLp,
  search,
  live,
  superChat,
  callError,
  insufficientPointSheet,
  preroutePrompt,
  banner,
  signupBonus,
  dailyBonus,
  gallery,
  footprint,
  bookmarkList,
  favorite,
  favoritesPage,
  likeList,
  settings,
  fleamarket,
  contact,
  media,
  demoCall,
  highReviewOnboarding,
  onboarding,
  forceUpdate,
  pushSoftAsk,
  autumnPointBack,
} as const;
